import { useNavigateBack } from '@exam-management/common/hooks';
import { useItemSet } from '@exam-management/common/item-set-provider';
import { useConfig } from '@exam-management/configuration';
import {
  ItemSetSubQuestionCreationForm,
  ItemSetSubQuestionCreationFormActions,
} from '@exam-management/qcontent-creation';
import {
  DetailSection,
  DetailSectionWrapper,
  GoToParagraphLink,
  ItemSetLocationsPreview,
  ItemSetSubQuestionInformationSection,
  LocationSectionWrapper,
  OwnerSection,
  PropertiesSection,
  QuestionLayout,
} from '@exam-management/qcontent-management';
import { useParams } from '@exam-management/router';
import { Button, Flex, PaperSection, VisibilityOutlinedIcon } from '@shared/components';
import { useEffect } from 'react';

export default function ItemSetCreateSubQuestionPage() {
  const { itemSet } = useItemSet();
  const { modules } = useConfig();
  const { structureId, questionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/create',
  );

  const maxSubQuestions = modules.qcontent.maxSubQuestions;

  const { handleBack } = useNavigateBack({
    fallbackPath: '/qbank-structures/:structureId/qcontents/item-set/:questionId',
    matchPatterns: '/qbank-structures/:structureId/qcontents/item-set/:questionId',
    fallbackParams: { structureId, questionId },
  });

  useEffect(() => {
    if (itemSet.totalQuestions >= maxSubQuestions) {
      handleBack();
    }
  }, [itemSet.totalQuestions, maxSubQuestions, handleBack]);

  if (itemSet.totalQuestions >= maxSubQuestions) {
    return null;
  }

  return (
    <ItemSetSubQuestionCreationForm>
      <QuestionLayout
        sideContent={
          <PaperSection title='Location'>
            <LocationSectionWrapper>
              <ItemSetLocationsPreview />
            </LocationSectionWrapper>
          </PaperSection>
        }
      >
        <Flex sx={{ width: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
          <PaperSection
            title='Question Details'
            endAdornment={
              <Button
                disabled
                color='secondary'
                variant='outlined'
                startIcon={<VisibilityOutlinedIcon />}
              >
                Preview Question
              </Button>
            }
          >
            <DetailSectionWrapper>
              <ItemSetSubQuestionInformationSection
                titleEndAdornment={
                  <GoToParagraphLink
                    to='/qbank-structures/:structureId/qcontents/item-set/:questionId'
                    params={{ structureId, questionId }}
                  />
                }
              />
              <DetailSection />
              <PropertiesSection />
              <OwnerSection />
            </DetailSectionWrapper>
          </PaperSection>
          <ItemSetSubQuestionCreationFormActions />
        </Flex>
      </QuestionLayout>
    </ItemSetSubQuestionCreationForm>
  );
}
